/* unplugin-vue-components disabled */import { render } from "./PopupAreas.vue?vue&type=template&id=097e9135&ts=true"
import script from "./PopupAreas.vue?vue&type=script&lang=ts"
export * from "./PopupAreas.vue?vue&type=script&lang=ts"

import "./PopupAreas.vue?vue&type=style&index=0&id=097e9135&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__